import { Link } from "react-router-dom";
import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getAdminSettlements } from "../api/adminSettlements";

const formatDate = (value) => value ? new Date(value).toLocaleDateString("nl-BE") : "-";
const money = (value) => `EUR ${Number(value || 0).toFixed(2)}`;

const statusLabel = (status) => status === "SETTLED" ? "Afgehandeld" : "Nog af te handelen";
const statusBadge = (status) => status === "SETTLED" ? "success" : "warning";

export default function AdminSettlements() {
  const [filter, setFilter] = useState("PENDING");
  const { data = [], isLoading, isError, error } = useQuery({
    queryKey: ["admin", "settlements"],
    queryFn: getAdminSettlements
  });

  const filtered = useMemo(() => {
    if (filter === "ALL") return data;
    return data.filter((settlement) => settlement.status === filter);
  }, [data, filter]);

  if (isLoading) return <div className="loading-state">Waarborgen laden...</div>;

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Waarborgen</h1>
          <p className="page-subtitle">Administratieve afhandeling van waarborgen na check-in.</p>
        </div>
      </header>

      <div className="panel panel-pad">
        <div className="segmented-control">
          <button className={filter === "PENDING" ? "active" : ""} onClick={() => setFilter("PENDING")}>Openstaand</button>
          <button className={filter === "SETTLED" ? "active" : ""} onClick={() => setFilter("SETTLED")}>Afgehandeld</button>
          <button className={filter === "ALL" ? "active" : ""} onClick={() => setFilter("ALL")}>Alles</button>
        </div>
      </div>

      {isError ? (
        <div className="panel panel-pad error-text">{error?.response?.data?.error || "Waarborgen ophalen mislukt."}</div>
      ) : filtered.length === 0 ? (
        <div className="panel empty-state">Geen waarborgen gevonden.</div>
      ) : (
        <div className="panel table-panel">
          <table className="data-table">
            <thead>
              <tr>
                <th>Status</th>
                <th>Reservatie</th>
                <th>Klant</th>
                <th>Trailer</th>
                <th>Check-in</th>
                <th>Waarborg</th>
                <th>Inhouding</th>
                <th>Terug te geven</th>
                <th>Actie</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((settlement) => (
                <tr key={settlement.id}>
                  <td><span className={`badge ${statusBadge(settlement.status)}`}>{statusLabel(settlement.status)}</span></td>
                  <td>#{settlement.reservationId}</td>
                  <td>{settlement.customer?.firstName || settlement.reservation?.firstName || ""} {settlement.customer?.lastName || settlement.reservation?.name || "-"}</td>
                  <td>{settlement.trailer?.name || settlement.reservation?.trailer?.name || "-"}</td>
                  <td>{formatDate(settlement.checkInInspection?.confirmedAt || settlement.reservation?.checkInAt)}</td>
                  <td>{money(settlement.depositAmount)}</td>
                  <td>{money(settlement.amountWithheld)}</td>
                  <td>{money(settlement.amountReturned)}</td>
                  <td>
                    <Link className={settlement.status === "PENDING" ? "button" : "button secondary"} to={`/admin/settlements/${settlement.id}`}>
                      {settlement.status === "PENDING" ? "Afhandelen" : "Bekijken"}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
